const i18n = {
  'en-US': {
    'login.form.title': 'Welcome back',
    'login.form.subtitle': 'Full link factory solution',
    'login.form.inviteRegisterSubtitle': '{company} invites you to register',
    'login.form.registerTitle': 'Create account',
    'login.form.registerSubtitle': 'Full link factory solution',
    'login.form.userName.errMsg': 'Username cannot be empty',
    'login.form.userName.label': 'Username',
    'login.form.loginAccount.errMsg': 'Phone number or email cannot be empty',
    'login.form.loginAccount.label': 'Phone number / Email',
    'login.form.loginAccount.placeholder': 'Please enter phone number or email',
    'login.form.loginAccount.invalid': 'Please enter a valid phone number or email',
    'login.form.phoneNumber.errMsg': 'Phone number cannot be empty',
    'login.form.phoneNumber.label': 'Phone number',
    'login.form.phoneNumber.placeholder': 'Please enter phone number',
    'login.form.phoneNumber.invalid': 'Please enter a valid phone number',
    'login.form.password.errMsg': 'Password cannot be empty',
    'login.form.login.errMsg': 'Login error, please refresh and try again',
    'login.form.userName.placeholder': 'Username',
    'login.form.email.label': 'Email',
    'login.form.email.placeholder': 'you@email.com',
    'login.form.email.errMsg': 'Email cannot be empty',
    'login.form.email.invalid': 'Please enter a valid email',
    'login.form.name.label': 'Name',
    'login.form.name.placeholder': 'Please enter name',
    'login.form.name.errMsg': 'Name cannot be empty',
    'login.form.companyName.label': 'Company name',
    'login.form.companyName.placeholder': 'Please enter company name',
    'login.form.companyName.errMsg': 'Company name cannot be empty',
    'login.form.password.label': 'Password',
    'login.form.password.length': 'Password must be at least 6 characters',
    'login.form.password.placeholder': 'Password',
    'login.form.confirmPassword.label': 'Confirm password',
    'login.form.confirmPassword.placeholder': 'Enter password again',
    'login.form.confirmPassword.errMsg': 'Please confirm your password',
    'login.form.confirmPassword.notMatch': 'The two passwords do not match',
    'login.form.inviteCode.label': 'Invite code',
    'login.form.inviteCode.placeholder': 'Please enter invite code',
    'login.form.inviteCode.errMsg': 'Invite code cannot be empty',
    'login.form.rememberPassword': 'Remember password',
    'login.form.forgetPassword': 'Forgot password',
    'login.form.login': 'Sign in',
    'login.form.registerSubmit': 'Create account',
    'login.form.register': 'register account',
    'login.form.switch.toRegisterPrefix': "Don't have an account?",
    'login.form.switch.toRegisterAction': 'Create one now',
    'login.form.switch.toLoginPrefix': 'Already have an account?',
    'login.form.switch.toLoginAction': 'Sign in now',
    'login.banner.slogan1': 'Out-of-the-box high-quality template',
    'login.banner.subSlogan1':
      'Rich page templates, covering most typical business scenarios',
    'login.banner.slogan2': 'Built-in solutions to common problems',
    'login.banner.subSlogan2':
      'Internationalization, routing configuration, state management everything',
    'login.banner.slogan3': 'Access visualization enhancement tool AUX',
    'login.banner.subSlogan3': 'Realize flexible block development',
    'login.banner.title': 'End-to-End Factory MES System',
    'login.banner.desc':
      'With efficiency and yield as core indicators, management improvement is driven through standard takt time, team-leader accountability, and dynamic benchmarking. The system focuses on recording and enables teams to analyze independently, periodically recalibrate takt time, and continuously optimize operational metrics.',
    'login.banner.tag.1': 'Efficiency & Yield',
    'login.banner.tag.2': 'Standard Takt Time',
    'login.banner.tag.3': 'Leader Accountability',
    'login.banner.tag.4': 'Dynamic Benchmarking',
    'login.banner.capability.1':
      'The system records process data and supports decisions instead of replacing team judgment.',
    'login.banner.capability.2':
      'Teams can analyze exceptions autonomously and periodically refine standard takt time.',
    'login.banner.capability.3':
      'Closed-loop reviews around business indicators continuously drive management improvement.',
    'login.msg.userOrPwdError': 'Error for user name or password',
    'login.msg.isNotAllowed': 'This account has been disabled. Please contact the administrator',
    'login.msg.title': 'Login remind',
    'login.msg.registerTitle': 'Register',
    'login.msg.registerSuccess': 'Registration successful, please sign in',
    'login.msg.registerFailed': 'Registration failed, please try again later',
    'login.lang.zh': 'Chinese',
    'login.lang.en': 'English',
    'login.systemName': 'MES System',
  },
  'zh-CN': {
    'login.form.title': '欢迎回来',
    'login.form.subtitle': '全链路工厂解决方案',
    'login.form.inviteRegisterSubtitle': '{company} 公司邀请您注册',
    'login.form.registerTitle': '创建新账号',
    'login.form.registerSubtitle': '全链路工厂解决方案',
    'login.form.userName.errMsg': '用户名不能为空',
    'login.form.userName.label': '用户名',
    'login.form.loginAccount.errMsg': '手机号码/邮箱不能为空',
    'login.form.loginAccount.label': '手机号码/邮箱',
    'login.form.loginAccount.placeholder': '请输入手机号码/邮箱',
    'login.form.loginAccount.invalid': '请输入正确的手机号码或邮箱',
    'login.form.phoneNumber.errMsg': '手机号码不能为空',
    'login.form.phoneNumber.label': '手机号码',
    'login.form.phoneNumber.placeholder': '请输入手机号码',
    'login.form.phoneNumber.invalid': '请输入正确的手机号码',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.login.errMsg': '登录出错，请刷新重试',
    'login.form.userName.placeholder': '用户名',
    'login.form.email.label': '邮箱地址',
    'login.form.email.placeholder': 'you@email.com',
    'login.form.email.errMsg': '邮箱不能为空',
    'login.form.email.invalid': '请输入正确的邮箱格式',
    'login.form.name.label': '姓名',
    'login.form.name.placeholder': '请输入姓名',
    'login.form.name.errMsg': '姓名不能为空',
    'login.form.companyName.label': '公司名称',
    'login.form.companyName.placeholder': '请输入公司名称',
    'login.form.companyName.errMsg': '公司名称不能为空',
    'login.form.password.label': '密码',
    'login.form.password.length': '密码至少 6 位',
    'login.form.password.placeholder': '密码',
    'login.form.confirmPassword.label': '确认密码',
    'login.form.confirmPassword.placeholder': '再次输入密码',
    'login.form.confirmPassword.errMsg': '确认密码不能为空',
    'login.form.confirmPassword.notMatch': '两次输入的密码不一致',
    'login.form.inviteCode.label': '邀请码',
    'login.form.inviteCode.placeholder': '请输入邀请码',
    'login.form.inviteCode.errMsg': '邀请码不能为空',
    'login.form.rememberPassword': '记住密码',
    'login.form.forgetPassword': '忘记密码？',
    'login.form.login': '登录账号',
    'login.form.registerSubmit': '注册账号',
    'login.form.register': '注册账号',
    'login.form.switch.toRegisterPrefix': '还没有账号？',
    'login.form.switch.toRegisterAction': '立即免费创建',
    'login.form.switch.toLoginPrefix': '已有账号？',
    'login.form.switch.toLoginAction': '立即登录',
    'login.banner.slogan1': '开箱即用的高质量模板',
    'login.banner.subSlogan1': '丰富的的页面模板，覆盖大多数典型业务场景',
    'login.banner.slogan2': '内置了常见问题的解决方案',
    'login.banner.subSlogan2': '国际化，路由配置，状态管理应有尽有',
    'login.banner.slogan3': '接入可视化增强工具AUX',
    'login.banner.subSlogan3': '实现灵活的区块式开发',
    'login.banner.title': '全链路工厂MES系统',
    'login.banner.desc':
      '以“效率与良率”为核心指标，通过标准节拍、班长负责制及动态数据对标，驱动管理改进。系统仅作记录，赋能团队自主分析、定期修正节拍，实现经营指标持续优化。',
    'login.banner.tag.1': '效率与良率',
    'login.banner.tag.2': '标准节拍',
    'login.banner.tag.3': '班长负责制',
    'login.banner.tag.4': '动态数据对标',
    'login.banner.capability.1': '系统仅作过程记录与数据沉淀，不替代团队决策',
    'login.banner.capability.2': '支持班组自主分析异常并定期修正标准节拍',
    'login.banner.capability.3': '围绕经营指标进行闭环复盘，持续推进管理改进',
    'login.msg.userOrPwdError': '用户名或密码错误',
    'login.msg.isNotAllowed': '该账户已被禁用，请联系管理员',
    'login.msg.title': '登录提示',
    'login.msg.registerTitle': '注册提示',
    'login.msg.registerSuccess': '注册成功，请登录',
    'login.msg.registerFailed': '注册失败，请稍后重试',
    'login.lang.zh': '中文',
    'login.lang.en': 'English',
    'login.systemName': 'MES系统',
  },
}

export default i18n
